<template>
  <header
    v-if="showHeader"
    id="header"
    :class="[hideDisplay]"
  >
    <div class="header_content">
      <div class="header_logo">
        <img src="@/assets/img/logo_myStage-GR.svg" />
      </div>
    </div>

    <div class="header_right_side_contents noprint">
      <div class="action_bar" v-if="this.isAllowedManageActions">
        <button type="button" class="action_btn" @click="downloadMessages()" :disabled="this.isDownloadDisabled">
          <span>{{ $t('chatBox.downloadChatCsv') }}</span>
        </button>

        <button type="button" class="action_btn" onclick="window.print()">
          <span>{{ $t('chatBox.printChat') }}</span>
        </button>
      </div>

      <div class="color_btn">
        <input
          id="TAB-04"
          @change="toggleTheme('light')"
          type="radio"
          name="TAB2"
          class="tab-switch_color"
          :checked="!this.chatThemeDark"
        />
        <label class="tab-label_color" for="TAB-04">
          <img src="@/assets/img/wht_icn@2x.png" />
        </label>
        <input
          id="TAB-05"
          value="blk"
          @change="toggleTheme('dark')"
          type="radio"
          name="TAB2"
          class="tab-switch_color"
          :checked="this.chatThemeDark"
        />
        <label class="tab-label_color" for="TAB-05">
          <img src="@/assets/img/blk_icn@2x.png" />
        </label>
      </div>

      <div class="header_help">
        <a class="ques_icon" :href="this.lessonDetails ? this.lessonDetails.faq_link : ''" target="_blank">?</a>
      </div>
    </div>

    <LessonExit v-if="showExitButton" :trial-logout="trialLesson && logout" />
  </header>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import LessonExit from '@/components/ChatHistory/Header/LessonExit';

export default {
  props: {
    hideDisplay: {
      type: String,
      default: ''
    },
    trialLesson: {
      type: Boolean,
      default: false
    },
    logout: {
      type: Boolean,
      default: false
    },
    vocabulary: {
      type: Boolean,
      default: false
    }
  },
  components: {
    LessonExit
  },
  computed: {
    ...mapState('layout', [
      'layoutColor',
      'isMobileSize'
    ]),
    ...mapGetters('modal', ['isModalShowing']),
    ...mapState('chatHistory', [
      'lessonDetails', 
      'chatThemeDark', 
      'isAllowedManageActions', 
      'isDownloadDisabled'
    ]),
    headerLogo() {
      return require(`@/assets/img/logo_${this.layoutColor}@2x.png`);
    },
    showExitButton() {
      return !this.trialLesson || (this.trialLesson && this.logout);
    },
    showHeader() {
      if (this.isMobileSize && this.isModalShowing) {
        return false;
      }

      return true;
    },
  },
  methods: {
    ...mapActions('chatHistory', ['toggleTheme', 'downloadMessages']),
  }
};
</script>

